import React from 'react';

import type { RadioButtonItemProps } from './radio-button-item';
import RadioButtonItem from './radio-button-item';

export interface RadioNavigationProps {
  elements: RadioButtonItemProps[];
}

const RadioNavigation: React.FC<RadioNavigationProps> = ({ elements }) => {
  return (
    <div>
      <div className="inline-flex grow-0 gap-1 rounded-lg bg-gray-100 p-1">
        {elements.map((element) => (
          <RadioButtonItem key={element.id} {...element} />
        ))}
      </div>
    </div>
  );
};

export default RadioNavigation;
